import { LayerInfo } from "../rendering/analyse/LayerInfo";
import { FrameVO } from "./FrameVO";

export class SpriteSheetVO {
    public pngURL: string;
    private _sheetName: string;
    private _frames: FrameVO[];
    private _layerInfos: LayerInfo[];
    private offsetX: number;
    private offsetY: number;
    private _isFilled: boolean = false;
    private _width: number = 0;
    private _height: number = 0;
    private _x: number = 0;
    private _y: number = 0;

    constructor(sheetName: string, pngURL: string, offsetX: number = 0, offsetY: number = 0) {
        this._sheetName = sheetName;
        this.pngURL = pngURL;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
    }

    public get frames(): FrameVO[] {
        return this._frames;
    }

    public get sheetName(): string {
        return this._sheetName;
    }

    public get layerInfos(): LayerInfo[] {
        return this._layerInfos;
    }

    public initJSON(json: string): void {
        this._frames = [];
        let jsonObject: any = JSON.parse(json);
        if (jsonObject.frames[0]) {
            let sizeObject: any = ((<any>jsonObject.frames[0]));
            if (sizeObject) {
                this._width = sizeObject.spriteSourceSize.w;
                this._height = sizeObject.spriteSourceSize.h;
                this._x = sizeObject.spriteSourceSize.x;
                this._y = sizeObject.spriteSourceSize.y;
            }
        }
        for (let frameParams of jsonObject.frames) {
            let frameVO: FrameVO = new FrameVO(this.offsetX, this.offsetY);
            frameVO.loadFromParamObject(frameParams);
            this._frames.push(frameVO);
        }
        this._layerInfos = [];
        for (let layerParams of jsonObject.fx) {
            let layer: LayerInfo = new LayerInfo(layerParams.x, layerParams.y, layerParams.scale, layerParams.index, layerParams.name, layerParams.rotation);
            this._layerInfos.push(layer);
        }
        this._isFilled = true;
    }

    public get isFilled(): boolean {
        return this._isFilled;
    }

    public get width(): number {
        return this._width;
    }

    public get height(): number {
        return this._height;
    }

    public get x(): number {
        return this._x - this.offsetX;
    }

    public get y(): number {
        return this._y - this.offsetY;
    }
}
